/**
 * This script fetches variant information for each link and displays the variant image in the respective <li> elements.
 * The variant image is loaded dynamically on page load using Shopify's AJAX API.
 * 
 * The script fetches the image data based on the variant ID stored on the page.
 */
document.addEventListener('DOMContentLoaded', function () {

    const isInline = document.querySelector(".super-downloads__modal-iframe-wrapper--inline") !== null;

    if (isInline) return;

    const variantItems = document.querySelectorAll('.super-downloads__item');

    variantItems.forEach(function (item) {
      const variantId = item.querySelector('.button--watch').getAttribute('data-variant-id');

      if (variantId) {

        // Fetch variant data using the Shopify AJAX API
        fetch(`/variants/${variantId}.js`)
          .then(response => response.json())
          .then(variant => {

            if (variant && variant.featured_image) {
              const variantImageContainer = item.querySelector('.super-downloads__variant-image-container');
              const variantImage = variantImageContainer.querySelector('img');
              
              variantImage.src = variant.featured_image;
              variantImage.alt = variant.name;
              variantImage.style.display = 'block';
            }
          })
          .catch(error => {
            console.error("Error fetching variant image:", error);
          });
      }
    });
  });
  